var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1363,
    y: 3.63651,
    width: 9.74189,
    height: 5.18336,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.17862,
    y: 12.2122,
    width: 5.04795,
    height: 5.18336,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7879,
    y: 12.2122,
    width: 5.13822,
    height: 5.18336,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.4106,
    y1: 14.7776,
    x2: 21.5136,
    y2: 14.7776,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.82812,
    y1: 20.4192,
    x2: 12.1709,
    y2: 20.4192,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.979,
    y1: 20.3742,
    x2: 29.3217,
    y2: 20.3742,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.101,
    y1: 8.59766,
    x2: 16.101,
    y2: 14.6907,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.66104,
    y1: 17.7148,
    x2: 7.66104,
    y2: 20.8291,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.28299,
    y1: 20.1973,
    x2: 3.28299,
    y2: 23.3115,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 11.7232,
    y1: 20.0615,
    x2: 11.7232,
    y2: 23.1758,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 20.2985,
    y1: 19.8813,
    x2: 20.2985,
    y2: 22.9956,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9191,
    y1: 19.9712,
    x2: 28.9191,
    y2: 23.0854,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 24.2703,
    y1: 17.7148,
    x2: 24.2703,
    y2: 20.8291,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.2569,
    cy: 25.636,
    r: 2.72708,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8323,
    cy: 25.636,
    r: 2.72708,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3627,
    cy: 25.636,
    r: 2.72708,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.893,
    cy: 25.636,
    r: 2.72708,
    stroke: "#1A82E2",
    strokeWidth: 0.909732
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvdIcon);
export default __webpack_public_path__ + "static/media/OVD_icon.7590e1650c011112be22c92344ef1a6f.svg";
export { ForwardRef as ReactComponent };